/**
 * Created by Daniela on 21/02/2017.
 */
import { Injectable } from '@angular/core';
import { Router } from "@angular/router";

import { DataService } from "../../../core/services/data.service";
import { UsuarioApiService } from "./usuario-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { usuariosStorage } from "./data.service";

@Injectable()
export class UsuarioService {
    constructor(
        private _router: Router,
        private _dataService: DataService,
        private _usuarioApiService: UsuarioApiService,
        private _utilService: UtilService
    ) { }

    setSessionStorageLogged(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(usuariosStorage + '-logged', object);
    }

    getSessionStorageLogged() {
        var item: string = sessionStorage.getItem(usuariosStorage + "-logged");
        return JSON.parse(item);
    }

    setStorageToken(item: string) {
        localStorage.setItem(usuariosStorage + '-token', item);
    }

    getStorageToken() {
        var item: string = localStorage.getItem(usuariosStorage + "-token");
        return item;
    }

    checkIsVisitor(): any {
        const url = this._router.url;
        if (url.indexOf('visitante') === -1) {
            return false;
        }

        let token = this._dataService.getToken();

        let tokenSplit: any = token.split(/\./);
        let userId = atob(tokenSplit[1]);
        return Number(userId);
    }

    getCredential(cookie: string) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this._dataService.setToken(Response.token);
                this.setStorageToken(Response.token);
                this.setSessionStorageLogged(Response);
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        this._usuarioApiService.onGetTokenByCookie(cookie, onDone);
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/usuarios/shared/usuario.service.ts
 **/